export default __webpack_public_path__ + "static/media/moon.1b124f8b.svg";